import type { MintDayOverride } from "./meme-calendar.overrides";

export const CUSTOM_EXTRA_MINT_DAYS: readonly MintDayOverride[] = [];
